"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Thumbnail Size',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.hasThumbnails;
  },
  type: _constants.INPUT_TYPES.NUMBER,
  "default": 120,
  min: 80,
  max: 300,
  description: "Set the size (width and height) of each of the thumbnails in the Thumbnail layout.\n  "
};
exports["default"] = _default;